import dayjs from 'utils/dayjs';
import ObjectUtils from '@spothero/utils/object';

import {spotheroGet} from 'api';

import {displayDateFormat} from 'hooks/config';
import {sendSentryException} from 'utils/error-handling';

/**
 * Gets a detailed list of inventory from the start of the current hour. Deleted rules are excluded.
 *
 * @param {number} id - The facility id.
 * @returns {Promise<{data: TInventoryRule[], totalDataRowCount: number}>}
 * @throws {Error} - The error message returned from the api.
 *
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/get_facilities_facility_id_inventory_rules_range
 * @see '/api/v1/facilities/{id}/inventory-rules-range/'
 */
const getRuleDisplay = async ({id}) => {
    try {
        const {
            data: {data, meta},
        } = await spotheroGet(`facilities/${id}/inventory-rules-range/`, {
            // eslint-disable-next-line camelcase
            range_starts: dayjs()
                .startOf('hour')
                .format(`${displayDateFormat}T00:00`),
        });

        return {
            data: ObjectUtils.camelizeKeys(data?.results) || [],
            totalDataRowCount: meta.count,
        };
    } catch (err) {
        sendSentryException(err);

        throw new Error(err.message);
    }
};

export default getRuleDisplay;
